var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0006,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3861 13.2113C23.7472 12.9304 24.2528 12.9304 24.6139 13.2113L33.6139 20.2113C33.8575 20.4007 34 20.692 34 21.0006V32.0006C34 32.7963 33.6839 33.5593 33.1213 34.1219C32.5587 34.6845 31.7957 35.0006 31 35.0006H17C16.2043 35.0006 15.4413 34.6845 14.8787 34.1219C14.3161 33.5593 14 32.7963 14 32.0006V21.0006C14 20.692 14.1425 20.4007 14.3861 20.2113L23.3861 13.2113ZM16 21.4897V32.0006C16 32.2658 16.1054 32.5202 16.2929 32.7077C16.4804 32.8953 16.7348 33.0006 17 33.0006H31C31.2652 33.0006 31.5196 32.8953 31.7071 32.7077C31.8946 32.5202 32 32.2658 32 32.0006V21.4897L24 15.2675L16 21.4897Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 24.0006C20 23.4483 20.4477 23.0006 21 23.0006H27C27.5523 23.0006 28 23.4483 28 24.0006V34.0006C28 34.5529 27.5523 35.0006 27 35.0006C26.4477 35.0006 26 34.5529 26 34.0006V25.0006H22V34.0006C22 34.5529 21.5523 35.0006 21 35.0006C20.4477 35.0006 20 34.5529 20 34.0006V24.0006Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink4);
export default __webpack_public_path__ + "static/media/icon-link4.025ad07aabe25664ea199aafd38b510c.svg";
export { ForwardRef as ReactComponent };